// Wait for GSAP to be loaded
function waitForGSAP() {
  return new Promise((resolve) => {
    if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
      // console.log('GSAP and ScrollTrigger loaded successfully');
      resolve();
    } else {
      console.log('Waiting for GSAP and ScrollTrigger to load...');
      const checkGSAP = () => {
        if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
          // console.log('GSAP and ScrollTrigger loaded successfully');
          resolve();
        } else {
          setTimeout(checkGSAP, 100);
        }
      };
      checkGSAP();
    }
  });
}

// Function to initialize animations
function initAnimations() {
  // console.log('Initializing product card animations...');
  
  // Select all product cards
  const productCards = document.querySelectorAll('.gsap-scroll-trigger');
  // console.log(`Found ${productCards.length} product cards with gsap-scroll-trigger class`);

  productCards.forEach((card, index) => {
    // console.log(`Setting up animations for card ${index + 1}`);
    
    // Image animation configuration
    const imageContainers = card.querySelectorAll('.gsap-image-container');
    // console.log(`Found ${imageContainers.length} image containers in card ${index + 1}`);
    
    gsap.from(imageContainers, {
      scrollTrigger: {
        trigger: card,
        start: 'top 90%',
        end: 'bottom 20%',
        toggleActions: 'play none none reverse',
      },
      y: 30,
      opacity: 0,
      duration: 0.4,
      ease: 'power2.out'
    });

    // Content animation configuration
    const contentContainer = card.querySelector('.gsap-content-container');
    if (contentContainer) {
      const contentElements = card.querySelectorAll('.gsap-content');
      // console.log(`Found ${contentElements.length} content elements in card ${index + 1}`);
      
      gsap.from(contentElements, {
        scrollTrigger: {
          trigger: contentContainer,
          start: 'top 90%',
          end: 'bottom 20%',
          toggleActions: 'play none none reverse',
        },
        y: 20,
        opacity: 0,
        duration: 0.3,
        stagger: 0.05,
        ease: 'power2.out'
      });
    }
  });
  
  console.log('Product card animations initialized successfully');
}

// Initialize animations when GSAP is ready
waitForGSAP().then(() => {
  // console.log('GSAP ready, registering ScrollTrigger plugin...');
  
  // Register ScrollTrigger plugin
  gsap.registerPlugin(ScrollTrigger);
  
  // Initialize animations when DOM is ready
  if (document.readyState === 'loading') {
    // console.log('DOM still loading, waiting for DOMContentLoaded...');
    document.addEventListener('DOMContentLoaded', initAnimations);
  } else {
    // console.log('DOM already loaded, initializing animations immediately...');
    initAnimations();
  }

  // Reinitialize animations when DOM is updated
  document.addEventListener('shopify:section:load', () => {
    // console.log('Shopify section loaded, reinitializing animations...');
    initAnimations();
  });
}).catch((error) => {
  console.error('Failed to load GSAP:', error);
});